import gql from "graphql-tag";

export const LeaderFragment = gql`
  fragment LeaderFragment on Leader {
    uid
    name
    leader_link
    created_at
    photo
    cityState
    socialOptOut
    details {
      about
      headline
      countryOfResidence
    }
    is_crosslister
    timeZone
    hasAvailabilitySet
    approved
    ownerOfSellerOrg {
      uid
    }
    teacherForSellerOrg {
      uid
      name
    }
    hasBackgroundCheckExpired
  }
`;
